/**
 * 教师管理 API
 */
import { request } from './request'

/**
 * 获取所有教师
 * 响应项应包含 gender: 0-未设置 1-男 2-女
 */
export function getTeachers() {
  return request('/api/teachers')
}

/**
 * 根据 user_id 获取教师
 * @param {number|string} userId - 用户 ID
 * 响应项应包含 gender: 0-未设置 1-男 2-女
 */
export function getTeacher(userId) {
  return request(`/api/teachers/${userId}`)
}

/**
 * 创建教师
 * @param {object} data - { user_id, name, gender?, contact, create_by? }
 * gender: 0-未设置 1-男 2-女
 */
export function createTeacher(data) {
  return request('/api/teachers', {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

/**
 * 更新教师
 * @param {number|string} userId - 用户 ID
 * @param {object} data - { name?, gender?, contact?, update_by? }
 */
export function updateTeacher(userId, data) {
  return request(`/api/teachers/${userId}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  })
}

/**
 * 删除教师
 * @param {number|string} userId - 用户 ID
 */
export function deleteTeacher(userId) {
  return request(`/api/teachers/${userId}`, {
    method: 'DELETE'
  })
}
